import Vue from 'vue'
import VueRouter from 'vue-router'
import MasterPage from './components/master/master'
import WelcomePanel from './views/welcome-panel'
import SettingsPage from './views/settings-page'
import ReceivedFilesPage from './views/received-files-page'
import UploadFilePage from './views/upload-file-page'
import ReceivedFilesMain from './components/received-files-view/received-files-main'
import ReceivedFilesFile from './components/received-files-view/received-files-file'
import LoginPage from './views/login-page'

import { store } from './store/store' //Just for login testing

//Add routing
const routes = [
    {
        path: '/', 
        component: MasterPage,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'welcome',
                component: WelcomePanel
            },
            {
                path: 'settings', 
                name: 'settings',
                component: SettingsPage
            },
            {
                path: 'receivedfiles',
                component: ReceivedFilesPage,
                children: [
                    {
                        path: '',
                        name: 'receivedfiles',
                        component: ReceivedFilesMain
                    },
                    /* {
                        path: 'inbox',
                        name: 'receivedfilesinbox',
                        component: ReceivedFilesMain,
                        props: { folderId: 0 }
                    }, */
                    {
                        path: 'folder/:folderId',
                        name: 'receivedfilesfolder',
                        component: ReceivedFilesMain,
                        props: (route) => ({ folderId: parseInt(route.params.folderId)})
                    },
                    {
                        path: 'file/:fileId',
                        name: 'receivedfilesfile',
                        component: ReceivedFilesFile,
                        props: (route) => ({ fileId: parseInt(route.params.fileId)})
                    }
                ],
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'uploadfile', 
                name: 'uploadfile',
                component: UploadFilePage
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage
    }
  ]
  
  Vue.use(VueRouter)
  
  const router = new VueRouter({
    mode: 'history',
    routes: routes
  })

  //Test route auth code
  router.beforeEach((to, from, next) => {
      if (to.matched.some(record => record.meta.requiresAuth)) {
          //if (localStorage.getItem('jwt') == null) {
            if (!store.state.loggedIn) { //Just for login testing
              next({
                  path: '/login',
                  params: {nextUrl: to.fullPath}
              })
          } else {
              next()
          }
      } else {
          next()
      }
  })

  export default router


// WEBPACK FOOTER //
// ./src/router.js